import { render } from "./LogoPlaceholder.vue?vue&type=template&id=03e7198d&scoped=true"
import script from "./LogoPlaceholder.vue?vue&type=script&lang=js"
export * from "./LogoPlaceholder.vue?vue&type=script&lang=js"

import "./LogoPlaceholder.vue?vue&type=style&index=0&id=03e7198d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e7198d"]])

export default __exports__